import { store } from "@/lib/store";
import { requirePermission } from "@/lib/permissions";
import {
  planAppointmentBulkUpload,
  type BulkUploadPlan,
  type PlannedAppointmentRow,
} from "@/app/shared/appointments/bulk-upload-plan";
import type { BulkUploadResult } from "@/app/shared/appointments/bulk-upload-import";
import { bookBulkUploadRows } from "@/services/appointment-booking.service";
import type { PmcAppointmentBulkUploadRow } from "@/app/shared/appointments/bulk-upload-parser";

export async function planBulkUpload(rows: PmcAppointmentBulkUploadRow[]): Promise<BulkUploadPlan> {
  await requirePermission("appointments.create");

  const orgId = store.getState().organization.activeOrgId;
  if (!orgId) {
    throw new Error("Organization not set");
  }

  return planAppointmentBulkUpload(rows, { kind: "pmc", clientOrgId: orgId });
}

export async function bulkUploadAppointments(
  planned: PlannedAppointmentRow[],
  onProgress?: (completed: number, total: number) => void
): Promise<BulkUploadResult> {
  return bookBulkUploadRows(planned, onProgress);
}
